/**
 * FRONT-2551: why an approval card is asking. The gate names the Policy row
 * that made the card appear (`details.policyRule`), so the card can say so and
 * point at the setting. Without it a card reads as Eddy suddenly asking, with
 * no hint that the person controls it.
 *
 * FRONT-3004: the card's footer (`ApprovalCardFooter`) says it now; this
 * module keeps the one reader of the row name.
 */
import type { Approval } from '~/hooks/queries/use-approvals';

/** The row name the gate sent, or null when the card has none (an app visitor's card, a pair with no row). */
export function policyRuleOf(approval: Approval): string | null {
  const d = approval.details;
  if (!d || typeof d !== 'object' || Array.isArray(d)) return null;
  const rule = (d as { policyRule?: unknown }).policyRule;
  return typeof rule === 'string' && rule.trim() ? rule : null;
}
